import React, { useEffect } from "react";
import { assets } from "../../Assets/assets";

const RefundPolicy = () => {

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="relative min-h-screen bg-white dark:bg-gray-950 overflow-hidden">

      <div
        className="absolute inset-0 opacity-[0.04] bg-repeat"
        style={{
          backgroundImage: `url(${assets.qqtlogo})`,
          backgroundSize: "180px",
        }}
      />

      <div className="relative z-10 max-w-5xl mx-auto px-6 py-12 text-gray-800 dark:text-gray-200">

        <h1 className="text-4xl font-bold mb-6 text-center">
          REFUND & CANCELLATION POLICY
        </h1>

        {/* <p className="mb-6 text-sm text-center text-gray-500">
          Effective Date: 20 April 2026
        </p> */}

        <Section title="1. Business Model Clarification">
          <ul className="list-disc pl-6 space-y-2">
            <li>A B2B trade facilitator</li>
            <li>An AI-based quotation service provider</li>
            <li>Aggregator and intermediary between the buyer and seller.</li>
            <li>Facilitates trade through making arrangement for Transport / shipping.</li>
            <li>Both the parties information (buyer and seller) remains confidential.</li>
          </ul>
        </Section>

        <Section title="2. Order Cancellation">
          <p>Before Confirmation</p>
          <ul className="list-disc pl-6 space-y-2">
            <li>Orders can be cancelled freely before confirmation.</li>
            <li>Buyer is free to choose one or more quotation, but not legally bound.</li>
          </ul>

          <p className="mt-3">After Confirmation</p>
          <ul className="list-disc pl-6 space-y-2">
            <li>An order once finalized has to be confirmed by making a letter of credit in the name of PCM Exports.</li>
            <li>PCM Exports will execute the order based on the letter of credit which will act as an official go-ahead instrument.</li>
            <li>An order once confirmed through LC, will not be cancelled in any case.</li>
            <li>LC will freeze the quotation terms like price, transport shipping cost etc.</li>
          </ul>
        </Section>

        <Section title="3. Refund Policy">
          <p>Platform Services</p>
          <ul className="list-disc pl-6 space-y-2">
            <li>If for any reason, QQT is unable to find a suitable supplier and provide at least 2 competitive quotations, then it has to return the platform fee taken to the buyer.</li>
          </ul>

          <p className="mt-3">Commodity Transactions</p>
          <ul className="list-disc pl-6 space-y-2">
            <li>Refunds depend on buyer agreement mentioned on the quotation.</li>
            <li>PCM Exports is not responsible for disputes unless directly involved as a contracting party.</li>
            <li>Once the quotation is accepted and LC is issued against it, all the price terms are frozen and supplier has to abide by the terms and conditions like price, quality parameters etc. and any deviation from the conditions will be considered to be a breach of contract and material will be returned to the supplier.</li>
            <li>PCM Exports may arrange another consignment for the same order (from another supplier) if the buyer gives consent to do so. Otherwise, the LC will be cancelled and only the service charge of PCM Exports has to be paid.</li>
          </ul>
        </Section>

        <Section title="4. Non-Refundable Cases">
          <ul className="list-disc pl-6 space-y-2">
            <li>Completed services</li>
            <li>Consultation fees</li>
            <li>Confirmed trade deals</li>
            <li>Loss due to market price changes</li>
            <li>Unproven quality issues (if false quality issue is raised by buyer and later found to be having mala fide intention)</li>
          </ul>
        </Section>

        <Section title="5. Refund Processing">
          <ul className="list-disc pl-6 space-y-2">
            <li>Approved refunds processed within 7–10 business days</li>
            <li>Mode: Original payment method</li>
          </ul>
        </Section>

        <Section title="6. Chargebacks">
          <p>
            Users agree not to initiate unjustified chargebacks. Any disputes should first be raised with PCM Exports.
          </p>
        </Section>

        <Section title="7. Dispute Resolution">
          <p>All disputes must be reported within 7 days of transaction.</p>
          <p>Contact:</p>
          <p>Email: pcmexportsbbsr@gmail.com</p>
          <p>Phone: 6752455372</p>
        </Section>
      </div>
    </div>
  );
};

const Section = ({ title, children }) => (
  <section className="mb-8">
    <h2 className="text-2xl font-semibold mb-3">{title}</h2>
    <div className="space-y-2">{children}</div>
  </section>
);

export default RefundPolicy;